import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/configuracoes/metas')({
  component: lazyRouteComponent(
    () => import('@/features/configuracoes/components/metas-tab'),
    'MetasTab'
  ),
})
